module.exports = "fragment SubscriptionMetadata on SubscriptionMetadata {\n  planOnCancel\n}\n"